module.exports = __webpack_public_path__ + "img/slow_mode.e1bf44ee.png";